import * as React from 'react';
import { connect } from 'react-redux';

import * as _ from 'lodash';

import './contact.scss';

const renderProfiles = (profile: any, index: number) => (
    <a href={profile.url} key={`profile-${index}`} target="_blank">
      <i className={`fab fa-${profile.network}`}/>
    </a>
);

const ContactComponent = (props: any) => {
  return (
      <article role="contact" id="contact">
        <h2>Contact me</h2>
        <h6>Have a project you'd like to discuss?</h6>
        <hr/>
        <i className="fa fa-comment"/>
        <h3>{props.name}</h3>
        <h6>
          <a href={`mailto:${props.email}`}>{props.email}</a>
          <span> - </span>
          <a href={`tel:${props.phone}`}>{props.phone}</a>
        </h6>
        <div role="social">
          {props.profiles.map(renderProfiles)}
        </div>
        <hr/>
        <h6 role="privacy">
          <a href="privacy-policy.pdf" target="_blank">Privacy Policy</a>
        </h6>
      </article>
  );
};

const mapStateToProps = (state: any) => {
  return {
    name: _.get(state.cv, 'basics.name'),
    email: _.get(state.cv, 'basics.email'),
    phone: _.get(state.cv, 'basics.phone'),
    profiles: _.get(state.cv, 'basics.profiles', []),
  };
};

export default connect(mapStateToProps, null)(ContactComponent);



// WEBPACK FOOTER //
// ./src/components/contact/contact.component.tsx